var map = {
	"./alphabet/components/Settings": 52,
	"./bee/components/Settings": 53,
	"./book/components/Settings": 439,
	"./gorbov/components/Settings": 54,
	"./memo/components/Settings": 50,
	"./metronom/components/Settings": 55,
	"./mnemo/components/Settings": 56,
	"./shulte/components/Settings": 51,
	"./speedtest/components/Settings": 57,
	"./spritz/components/Settings": 58,
	"./strup/components/Settings": 59,
	"./temp/components/Settings": 440,
	"./texts/components/Settings": 30,
	"./wedge/components/Settings": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;